import {useState, useEffect} from 'react';
import {useHistory, useLocation} from 'react-router-dom';

import {DEFAULT_LOCALE, LANGUAGE_QUERY_PARAM} from 'utils/i18n';
import createLocation from 'utils/createLocation';
import queryparse from 'tricks/string/queryparse';

const useUserLocale = ({languageQueryParam = LANGUAGE_QUERY_PARAM} = {}) => {
	const location = useLocation();
	const history = useHistory();
	const {[languageQueryParam]: lang} = queryparse(location.search);
	// if language is not set in query params, try to get it from localStorage
	const storedLanguage = JSON.parse(localStorage.getItem('language'));
	const [locale, setLocale] = useState(
		lang || storedLanguage || DEFAULT_LOCALE
	);

	useEffect(() => {
		const storedLanguage = JSON.parse(localStorage.getItem('language'));
		setLocale(lang || storedLanguage || DEFAULT_LOCALE);
	}, [lang]);

	const changeLocale = locale => {
		history.replace(
			createLocation(location, {
				[languageQueryParam]: locale,
			})
		);
	};

	return {
		locale,
		changeLocale,
	};
};

export default useUserLocale;
